import type { AnalyticsUser } from './types';

/**
 * Identify user to Tiktok Pixel.
 *
 * @param user
 */
export const setUserForSnapPixel = async (user: AnalyticsUser): Promise<void> => {
  if (window.snaptr) {
    window.snaptr('init', window.snapPixelID, {
      phone: user.phone,
    });
  }
};

/**
 * Track signup conversion.
 */
export const trackSignedUpForSnap = (): void => {
  if (window.snaptr) {
    window.snaptr('track', 'SIGN_UP');
  }
};

/**
 * Track onboarded conversion.
 */
export const trackOnboardedForSnap = (): void => {
  if (window.snaptr) {
    window.snaptr('track', 'ADD_CART');
  }
};
